export function forgotInRequest(subdominio, usuario, cpf) {
  return {
    type: '@forgot/FORGOT_IN_REQUEST',
    payload: {subdominio, usuario, cpf },
  };
}

export function forgotInSuccess(usuario, cpf) {
  return {
    type: '@forgot/FORGOT_IN_SUCCESS',
    payload: {usuario, cpf },
  };
}

export function forgotFailure() {
  return {
    type: '@forgot/FORGOT_FAILURE',
  };
}

export function forgotOut() {
  return {
    type: '@forgot/FORGOT_OUT',
  };
}
